import React from 'react'
import { withRouter } from 'react-router'
import { Omit } from 'types'

export interface UserLayerProps {
  openUserLayer: (userId: string) => void
}

const withUserLayer = <P extends UserLayerProps>(
  WrappedComponent: React.ComponentType<P>
) => (
  withRouter(({ history, location, match, staticContext, ...props }) => (
    <WrappedComponent
      {...props as P}
      openUserLayer={(userId) => {
        const search = new URLSearchParams(history.location.search)
        search.set('userLayer', userId)

        history.push(location.pathname + '?' + search)
      }}
    />
  )) as unknown as React.ComponentType<Omit<P, keyof UserLayerProps>>
)

export default withUserLayer
try {
    // @ts-ignore
    withUserLayer.displayName = "withUserLayer";
    // @ts-ignore
    withUserLayer.__docgenInfo = { "description": "", "displayName": "withUserLayer", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/UserLayer/withUserLayer.tsx#withUserLayer"] = { docgenInfo: withUserLayer.__docgenInfo, name: "withUserLayer", path: "src/components/UserLayer/withUserLayer.tsx#withUserLayer" };
}
catch (__react_docgen_typescript_loader_error) { }